import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useNetworkName } from "Flocknote/stateHooks";

const DefaultDocumentTitle = () => {
  const { pathname } = useLocation();
  const [networkName] = useNetworkName();

  useEffect(() => {
    if (!pathname.startsWith("/giving") && networkName) {
      document.title = `${networkName} // Flocknote`;
    }
  }, [pathname, networkName]);

  return null;
};

export default DefaultDocumentTitle;
